<template>
  <div>
    <div slot="title">
      <div></div>
      <h2>Reporte de Interinatos</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        
        <div class="row">
          <div class="col-4">
            <C001Area :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Todas"
                      :idDelInput="'catalogoArea'"
                      v-on:valorParaElPadre="cambioArea"
                      :parametros="parametros_Area"
                      :valorDefinido="parametros_Area.valorDefinido"></C001Area>
          </div>
          <div class="col-1 padding-0">
            <button type="submit" class="form-control" @click="buscarEvaluaciones"><i class="fa fa-search"></i></button>
          </div>
        </div>        
        <div class="row" style="margin-top:30px;">
          <div class="col-5"></div>
          <div class="col-3">
            <input type="button" v-if="evaluaciones.length > 0" class="form-control" @click="descargarArchivo" value="Generar Reporte en Excel">
          </div>
          <div class="col-3 padding-0">
            <input type="button" v-if="evaluaciones.length > 0" class="form-control" @click="generarReporte" value="Generar Reporte">
          </div>
        </div>
        
        <div class="row">
          <div class="col-12">
            <h4 v-if="evaluaciones.length > 0">Resultados ({{evaluaciones.length}})</h4>
            <hr />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
              <tbody class='text-dark'>
                <tr v-for="evaluacion in evaluaciones">
                  <td>{{evaluacion.col1}}</td>
                  <td>{{evaluacion.col2}}</td>
                  <td>{{evaluacion.col3}}</td>
                  <td>{{evaluacion.col4}}</td>
                  <td>{{evaluacion.col5}}</td>
                  <td>{{evaluacion.col6}}</td>
                  <td>{{evaluacion.col7}}</td>
                  <td>{{evaluacion.col8}}</td>
                  <td>{{evaluacion.col9}}</td>
                  <td>{{evaluacion.col10}}</td>
                  <td>{{evaluacion.col11}}</td>
                  <td>{{evaluacion.col12}}</td>
                  <td>{{evaluacion.col13}}</td>
                  <td>{{evaluacion.col14}}</td>
                </tr>
                <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones contestadas en el periodo marcado.</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import catalogos from "@/../static/js/catalogos";
  import comun from "@/../static/js/comun";
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'
  import highcharts from '@/../static/js/highchart'

  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        evaluaciones: [
        ],
        rutaArchivo: "",
        NumeroFilasPagina: 1000,
        parametros_Area: {
          valorDefinido: 0,
          areaId: null
        },
      }
    },
    components: {
      highcharts,
      C001Area: catalogos.PJ.C001Area
    },
    methods: {
      buscarEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "areaId": this.parametros_Area.areaId
        };        
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GetReporteInterinatos, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.evaluaciones = response.data.FilasReporte//Carga los datos necesarios
            this.rutaArchivo = response.data.RutaReporte;

            this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', this.NumeroFilasPagina)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },      
      generarReporte: function () {

        var popupWin = window.open('', '_blank', 'width=750,height=600,location=no,left=100px');
        popupWin.document.open();
        popupWin.document.write('<html><head><title>Reporte de Evaluaciones</title>');
        popupWin.document.write('<style>  tr.page-break  { display: block; page-break-after: always; }</style>');
        popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
        popupWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
        popupWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
        popupWin.document.write('</head><body >')
        popupWin.document.write('<h2>Reporte de Evaluaciones</h2>')

        popupWin.document.write('<div style=" display: block; page-break-inside: avoid; position: relative;"><table class="table table-striped table-light table-hover">')
        var resultados = document.getElementById('tablaEvaluaciones').innerHTML;
        //console.log(resultados.indexOf('style="display: none; opacity: 0;"'));
        resultados = resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        resultados = resultados.split('style="opacity: 0; display: none;"').join('style="opacity: 1; display: table-row;"');
        //console.log(resultados.indexOf('class="visible-element"'));
        resultados = resultados.split('class="visible-element"').join('style="display: none"');
        resultados = resultados.split('class="salto" style="opacity: 1; display: table-row;"></tr>').join('class="salto"></tr></table></div><div style=" display: block; page-break-before: always;page-break-inside: avoid; position: relative;"><table class="table table-striped table-light table-hover">');
        //resultados = resultados.split('class="hidden-element"').join('style="opacity: 1"');
        //resultados = resultados.split('</td></tr>').join('</td></tr><tr><th>Nombre</th><th>Resultado</th><th>Intrapersonal</th><th>InterPersonal</th><th>Desarrollo de Tareas</th><th>Entorno</th><th>Gerencia</th><th>Áreas de Oportunidad</th><th class="visible-element">Acciones</th></tr>');
        //resultados.split('style="display: none; opacity: 0;"').join('style="opacity: 1; display: table-row;"');
        console.log(resultados);
        popupWin.document.write(resultados);
        popupWin.document.write('</table></div>');
        popupWin.document.write('</body></html>');
        var css = '@page { size: landscape; }',
          head = popupWin.document.head || document.getElementsByTagName('head')[0],
          style = popupWin.document.createElement('style');

        style.type = 'text/css';
        style.media = 'print';

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(popupWin.document.createTextNode(css));
        }

        head.appendChild(style);
        setTimeout(function () { popupWin.print(); }, 1000)
        popupWin.document.close();
        popupWin.focus();
        this.ImpresionConcluida = true;
      },
      descargarArchivo: function () {
        if (this.rutaArchivo != undefined) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.rutaArchivo}`
          console.log(a.href);
          a.click();
        }
      },
      cambioArea(datos) { //Administra los cambios en el componente de Área
        catalogos
        this.parametros_Area.areaId = parseInt(datos.target.value)
      },
       
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      
      //this.buscarEvaluaciones()
    },
    beforeDestroy() {
    }, computed: {
      
    }

  }

</script>

<style scoped>

  .padding-0 {
    padding-right: 1px;
    padding-left: 1px;
  }

  .hidden-element {
    opacity: 0;
  }

  .visible-element {
    opacity: 1;
  }


  .page-break {
    display: block;
    page-break-after: always;
    page-break-inside: avoid;
    position: relative;
  }

  .page-nobreak {
    display: block;
    page-break-after: avoid;
  }


  .lista-competencias p {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/ReporteInterinatos.vue